module.exports = __webpack_public_path__ + "static/media/anchor.fw.d884a75b.png";